export const locale = {
  lang: 'fr-CA',
  data: {
    PRODUCT_UPSELL_PANEL: {
      TITLE: 'Suggestions (upsell)',
      HINT: 'Produits suggérés au client dans la boutique en ligne quand ce produit est ajouté au panier. Jamais bloquant.',
      SEARCH: 'Rechercher un produit du catalogue',
      TYPE_TO_SEARCH: 'Tapez au moins 2 caractères pour chercher',
      LEFT_LIST_LABEL:
        'Glisser et déposer ou utiliser le bouton + pour ajouter des produits',
      RIGHT_LIST_LABEL: "Suggestions (dans l'ordre d'affichage)",
      NO_RESULTS: 'Aucun résultat',
      NO_SUGGESTIONS: 'Aucune suggestion pour ce produit.',
      SHARED_WARNING:
        "Ces suggestions sont partagées avec {{count}} autre(s) produit(s) — les modifications s'appliqueront à tous.",
      ADVANCED: 'Options du panneau client',
      TITLE_HINT:
        'Titre affiché au client dans le panneau de suggestions. Laisser vide pour utiliser le titre par défaut.',
      TITLE_FR: 'Titre (FR)',
      TITLE_EN: 'Titre (EN)',
      TITLE_DEFAULT_FR: 'Vous aimeriez aussi…?',
      TITLE_DEFAULT_EN: 'You might also like…?',
      IS_ACTIVE: 'Actif dans la boutique',
      CHECKOUT_TRIGGER: 'Afficher aussi au passage à la caisse',
      CHECKOUT_TRIGGER_NONE: 'Non',
      CHECKOUT_TRIGGER_TRIGGER_PRODUCT: 'Si le panier contient ce produit',
      CHECKOUT_TRIGGER_ALCOHOLIC_PRODUCT:
        'Si le panier contient un produit alcoolisé',
      CHECKOUT_TRIGGER_ALWAYS: 'Toujours',
      CHECKOUT_TRIGGER_HINT:
        "Le panneau s'ouvre une fois quand le client arrive à la page de paiement, en plus de l'ajout du produit.",
    },
  },
};
